import { render, staticRenderFns } from "./VehicleReviewDialog.vue?vue&type=template&id=ba399ec6&scoped=true"
import script from "./VehicleReviewDialog.vue?vue&type=script&lang=js"
export * from "./VehicleReviewDialog.vue?vue&type=script&lang=js"
import style0 from "./VehicleReviewDialog.vue?vue&type=style&index=0&id=ba399ec6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba399ec6",
  null
  
)

export default component.exports